import api from '../../plugins/api';

// POST /crm/cars/uploadStock/commit — подтверждение вручную исправленных строк стока,
// которые не прошли автоматический импорт (см. uploadStock -> pendingRows/sessionId)
const commitStockCorrections = (sessionId, rows) => {
  return api.post('/api/crm/cars/uploadStock/commit', { sessionId, rows });
};

export default commitStockCorrections;
